import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

// Разделы рабочего стола: текущие заказы и обращения в поддержку
export const DESKTOP_SECTION = {
  ORDERS: "orders",
  APPEALS: "appeals",
} as const;

export type DesktopSection =
  (typeof DESKTOP_SECTION)[keyof typeof DESKTOP_SECTION];

interface IDesktopState {
  section: DesktopSection;
  activeOrderId?: number;
  ordersDateFrom?: string;
  ordersDateTo?: string;
  activeAppealId?: number;
  appealStatus: number;
  appealsDateFrom?: string;
  appealsDateTo?: string;
  messageText: string;
}

const initialState: IDesktopState = {
  section: DESKTOP_SECTION.ORDERS,
  messageText: "",
  appealStatus: 1,
};

const desktopSlice = createSlice({
  name: "desktop",
  initialState,
  reducers: {
    setDesktopSection(state, action: PayloadAction<DesktopSection>) {
      state.section = action.payload;
    },
    setActiveOrderId(state, action: PayloadAction<Undefinable<number>>) {
      if (state.activeOrderId === action.payload)
        state.activeOrderId = undefined;
      else state.activeOrderId = action.payload;
    },
    setOrdersDateFrom(state, action: PayloadAction<Undefinable<string>>) {
      state.ordersDateFrom = action.payload;
    },
    setOrdersDateTo(state, action: PayloadAction<Undefinable<string>>) {
      state.ordersDateTo = action.payload;
    },
    setActiveAppealId(state, action: PayloadAction<Undefinable<number>>) {
      if (state.activeAppealId === action.payload)
        state.activeAppealId = undefined;
      else state.activeAppealId = action.payload;
    },
    setAppealStatus(state, action: PayloadAction<number>) {
      state.appealStatus = action.payload;
    },
    setAppealsDateFrom(state, action: PayloadAction<Undefinable<string>>) {
      state.appealsDateFrom = action.payload;
    },
    setAppealsDateTo(state, action: PayloadAction<Undefinable<string>>) {
      state.appealsDateTo = action.payload;
    },
    setMessageText(state, action: PayloadAction<string>) {
      state.messageText = action.payload;
    },
  },
});

export const {
  setDesktopSection,
  setActiveOrderId,
  setOrdersDateFrom,
  setOrdersDateTo,
  setActiveAppealId,
  setAppealStatus,
  setAppealsDateFrom,
  setAppealsDateTo,
  setMessageText,
} = desktopSlice.actions;

export const desktopReducer = desktopSlice.reducer;
